'use client';

/**
 * @brisa/ui · components/ui/label — shadcn Label (Facelift v1)
 *
 * Feature: migracao-facelift-v1 · ADR §D6
 *
 * Wrapper sobre @radix-ui/react-label — gerencia associação via htmlFor/id
 * + propaga focus/disable do Input associado.
 *
 * 'use client' obrigatório (F1-RSC-06) — Radix primitives requerem boundary.
 */
import * as React from 'react';
import * as LabelPrimitive from '@radix-ui/react-label';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '../../lib/utils';

const labelVariants = cva(
  'text-sm font-medium leading-none text-[hsl(var(--text-80))] ' +
    'peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
);

export interface LabelProps
  extends React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root>,
    VariantProps<typeof labelVariants> {}

export const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  LabelProps
>(({ className, ...props }, ref) => (
  <LabelPrimitive.Root ref={ref} className={cn(labelVariants(), className)} {...props} />
));
Label.displayName = LabelPrimitive.Root.displayName;
